import {
  Droplets,
  Disc3,
  Armchair,
  Volume2,
  Zap,
  Shield,
  Sun,
  Sparkles,
  KeyRound,
} from "lucide-react";

export const CONTACT = {
  phone: "7010080038",
  phoneDisplay: "+91 70100 80038",
  phoneLink: "tel:+917010080038",
  phone2: "9042438630",
  phone2Display: "+91 90424 38630",
  phone2Link: "tel:+919042438630",
  address: "NH.83, Bypass Road, Shanmuganathi, Palani, 624601",
  hours: "Mon – Sat · 8:30 AM – 7:30 PM",
  mapsUrl: "https://maps.app.goo.gl/LgtmczoAckcf9B759",
  whatsappUrl:
    "https://wa.me/917010080038?text=Hi%20Bowegans%20Car%20Care!%20I%20want%20to%20book%20a%20service%20for%20my%20car.",
};

export const IMAGES = {
  audio: "/audio.jpg",
  sunfilm: "/sunfilm.jpg",
  ppf: "/ppf.jpg",
  led: "/led.jpg",
  bodykit: "/bodykit.jpg",
  carkey: "/carkey.jpg",
  hero: "https://images.unsplash.com/photo-1580014317999-e9f1936787a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  garage: "https://images.unsplash.com/photo-1769641241120-f0dd8669b12d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  coupe: "https://images.unsplash.com/photo-1619692460304-67fd2b1e436d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  seats: "/seats.jpg",
  alloyDetail: "https://images.unsplash.com/photo-1573939843624-b22996c1a31c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  alloySpoke: "https://images.unsplash.com/photo-1785139164960-7c61c38abf8a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  foam: "https://images.unsplash.com/photo-1633014041037-f5446fb4ce99?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spray: "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  handwash: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    id: "water-wash",
    title: "Foam & Underbody Water Wash",
    category: "Maintenance & Detailing",
    description:
      "High-pressure hydraulic foam wash, deep wheel-well cleaning, and interior vacuuming for a showroom finish.",
    badge: "Popular",
    icon: Droplets,
    image: IMAGES.foam,
  },
  {
    id: "alloy-wheels",
    title: "Custom Alloy Wheels & Rims",
    category: "Exterior Styling",
    description:
      "Precision fitting of lightweight forged and cast alloy wheels in matte, gloss, and dual-tone finishes.",
    badge: "Bespoke",
    icon: Disc3,
    image: IMAGES.alloyDetail,
  },
  {
    id: "seat-covers",
    title: "Custom Leather Seat Covers",
    category: "Interior Luxury",
    description:
      "Hand-stitched OEM fit bucket seat covers in premium Nappa, perforated leatherette, and custom diamond quilting.",
    badge: "Handcrafted",
    icon: Armchair,
    image: IMAGES.seats,
  },
  {
    id: "audio-systems",
    title: "High-End Car Audio Systems",
    category: "Electronics & Sound",
    description:
      "DSP sound tuning, component speakers, heavy-bass subwoofers, android touchscreens, and 3-layer damping sheets.",
    badge: "Hi-Res Audio",
    icon: Volume2,
    image: IMAGES.audio,
    imgPos: "center 30%",
  },
  {
    id: "lighting",
    title: "LED & Laser Headlight Upgrades",
    category: "Performance Lighting",
    description:
      "Projector lens retrofits, ambient interior neon, matrix DRLs, and ultra-bright LED fog lights for enhanced night visibility.",
    badge: "High Beam",
    icon: Zap,
    image: IMAGES.led,
  },
  {
    id: "body-kits",
    title: "Aerodynamic Body Kits & Spoilers",
    category: "Performance Aerodynamics",
    description:
      "Custom front bumpers, side skirts, rear diffusers, carbon fiber accents, and custom exhausts fitting.",
    badge: "Aggressive",
    icon: Shield,
    image: IMAGES.bodykit,
  },
  {
    id: "sunfilm",
    title: "Heat Rejection Sunfilm",
    category: "Solar & Privacy Protection",
    description:
      "High-IR ceramic sun control films providing up to 99% UV protection and superior cabin cooling without signal disruption.",
    badge: "99% UV Shield",
    icon: Sun,
    image: IMAGES.sunfilm,
  },
  {
    id: "ppf",
    title: "Paint Protection Film (PPF)",
    category: "Self-Healing Armor",
    description:
      "Ultra-clear TPU self-healing paint protection film shielding your vehicle from stone chips, scratches, and swirl marks.",
    badge: "10-Yr Warranty",
    icon: Sparkles,
    image: IMAGES.ppf,
  },
  {
    id: "car-key",
    title: "Car Key Solutions",
    category: "Key Programming & Security",
    description:
      "All type of car keys — CLONING, UPGRADE TO FLIP KEY AND SMART KEYS.",
    badge: "New",
    icon: KeyRound,
    image: IMAGES.carkey,
  },
];

export const SHORT_NAMES = {
  "water-wash": "Water Wash",
  "alloy-wheels": "Alloy Wheels",
  "seat-covers": "Seat Covers",
  "audio-systems": "Audio Systems",
  lighting: "LED Headlights",
  "body-kits": "Body Kits",
  sunfilm: "Sunfilm",
  ppf: "PPF Protection",
  "car-key": "Car Keys",
};

export const MARQUEE_ITEMS = [
  "WATER WASH",
  "ALLOY WHEELS",
  "SEAT COVERS",
  "AUDIO SYSTEMS",
  "LIGHTING",
  "BODY KITS",
  "SUNFILM",
  "PPF PROTECTION",
  "CAR KEYS",
  "PALANI NH.83",
];

export const CHAPTERS = [
  {
    number: "01",
    title: "The Palani Aftermarket Hub",
    text: "Located prominently on NH.83 Bypass Road, Shanmuganathi, Palani, Bowegans Car Care was built for car enthusiasts who refuse standard factory limitations.",
  },
  {
    number: "02",
    title: "Zero-Compromise Craftsmanship",
    text: "From wire-harnessing audio upgrades without cutting original wires to vacuum-sealing PPF protection, our master technicians treat every vehicle like a flagship specimen.",
  },
  {
    number: "03",
    title: "End-to-End Car Customization",
    text: "Whether it is an aggressive stance with lightweight alloy wheels or immersive cabin soundproofing, we bring international aftermarket culture to Tamil Nadu.",
  },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STORE_URL = process.env.REACT_APP_STORE_URL;
